import Header from 'components/Header/Header';
import Loader from 'components/Loader';
import { useAuth } from 'context/AuthProvider/AuthProvider';
import AppRoutes from 'routes/Routes';

const App = () => {
  const { isSignedIn } = useAuth();

  return (
    <div data-testid="app">
      <>
        <Header />
        {isSignedIn ? <AppRoutes /> : <Loader />}
      </>
    </div>
  );
};

export default App;
